import React from 'react'
import clsx from 'clsx'

import Box from '@mui/material/Box'
import BlurIcon from '@mui/icons-material/BlurLinear'
import NoneIcon from '@mui/icons-material/NotInterestedOutlined'
import { useTheme } from '@mui/material'

import { useSessionContext } from '../../../contexts/SessionContext'
import { useBackgroundModalStyles } from '../styles'

export type Thumbnail = 'none' | 'blur' | 'image'

const icons = {
  none: NoneIcon,
  blur: BlurIcon,
  image: null,
}
interface BackgroundThumbnailProps {
  thumbnail: Thumbnail;
  imagePath?: string;
  name?: string;
  index?: number;
}

const BackgroundThumbnail = ({ 
  thumbnail, 
  imagePath, 
  name, 
  index 
}: BackgroundThumbnailProps) => {
  const theme = useTheme()
  const styles = useBackgroundModalStyles()
  const ThumbnailIcon = icons[thumbnail]
  const { backgroundSettings, setBackgroundSettings } = useSessionContext()

  const isImage = thumbnail === 'image';
  const thumbnailSelected = isImage
    ? backgroundSettings.index === index && backgroundSettings.type === 'image'
    : backgroundSettings.type === thumbnail;

  return (
    <Box
      sx={styles.thumbContainer}
      onClick={() =>
        setBackgroundSettings({
          type: thumbnail,
          index: !index ? -1 : index,
        })
      } >
      {ThumbnailIcon ? (
        <Box 
          sx={styles.thumbIconContainer}
          border={thumbnailSelected ? `solid ${theme.palette.primary.main}` : `solid ${theme.palette.grey[400]}`} >
          <ThumbnailIcon 
            sx={styles.thumbIcon} />
        </Box>
      ) : (
        <img 
          className={clsx(styles.thumbImage, { selected: thumbnailSelected })} 
          src={imagePath} 
          alt={name} />
      )}
      <Box 
        sx={styles.thumbOverlay}>
        {name}
      </Box>
    </Box>
  )
}

export default BackgroundThumbnail